import _classCallCheck from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import * as r from "restructure";
var ImageData = /*#__PURE__*/function () {
  function ImageData() {
    _classCallCheck(this, ImageData);
  }
  _createClass(ImageData, [{
    key: "decode",
    value: function decode(stream) {
      var buffer = stream.buffer.slice(stream.pos);
      var length = 0;
      var i = buffer.indexOf(0xff);
      while (i !== -1) {
        length = i;
        var nextByte = buffer[length + 1];
        var comesRestart = nextByte >= 0xd0 && nextByte <= 0xd7;
        if (nextByte !== 0x00 && !comesRestart) break;
        i = buffer.indexOf(0xff, i + 1);
      }
      stream.pos += length;
      return buffer.slice(0, length);
    }
  }]);
  return ImageData;
}();
var SOSComponentSpecification = new r.Struct({
  scanComponentSelector: r.uint8,
  entropyCodingTable: new r.Buffer(1)
});
var SOSMarker = {
  name: function name() {
    return "SOS";
  },
  length: r.uint16be,
  numberOfImageComponents: r.uint8,
  componentSpecifications: new r.Array(SOSComponentSpecification, function (parent) {
    return parent.numberOfImageComponents;
  }),
  startOfSpectral: r.uint8,
  endOfSpectral: r.uint8,
  successiveApproximationBit: new r.Buffer(1),
  data: new ImageData()
};
export default SOSMarker;